export enum WorkSchedule {
    FORTY_HOUR = 'The same schedule each week, 8 hours a day, Monday through Friday',
    REGULAR = 'The same schedule each week, but not 8 hours a day, Monday through Friday',
    ROTATING = 'A rotating schedule (eg. Monday through Wednesday on odd weeks, Tuesday through Friday on even weeks)',
    ALTERNATIVE = 'A different schedule every week'
}